module.exports = __webpack_public_path__ + "img/2.177b214b.png";